import { Component, OnInit, ViewChild, ElementRef, Input, EventEmitter, Output } from '@angular/core';
import { FileUploadStatus } from '../models/file-upload-status';
import { LocalStorageService } from 'src/app/shared/util/local-storage';
import { RainUploadQueryProgressService } from '../services/rain-upload-query-progress/rain-upload-query-progress.service';
import { RainUploadProgress } from '../models/rain-upload-progress';
import { TimespanService } from 'src/app/instant-analysis/services/timespan/timespan.service';
import { ServiceService } from 'src/app/instant-analysis/services/service.service';
import { FileUploaderService } from '../services/file-uploader/file-uploader.service';
import { HttpClient } from '@angular/common/http';

/**
 * Componente do upload das planilhas de chuvas. Permite fazer upload de várias
 * planilhas de uma vez.
 */
@Component({
  selector: 'app-rain-file-uploader',
  templateUrl: './rain-file-uploader.component.html',
  styleUrls: ['./rain-file-uploader.component.css'],
  providers: [
    { 
      provide: FileUploaderService, 
      useFactory: (http: HttpClient) => {
        return new FileUploaderService('chuva/upload', http);
      }, 
      deps: [HttpClient],
    }
  ]
})
export class RainFileUploaderComponent implements OnInit {

  /** Indica o nome do arquivo, ou uma mensagem para selecionar um arquivo csv. */
  selectedFile: File = null;

  /** ID da estação selecionada */
  selectedStation: any;

  /** Enum com as opções possíveis do status do envio do arquivo de chuvas. */
  FileUploadStatus = FileUploadStatus;

  /** Indica o status atual do envio de um arquivo de chuvas. */
  currentFileUploadStatus: FileUploadStatus = FileUploadStatus.IDLE;

  /** Detalhes do progresso do upload das planilhas. */
  uploadProgressDetails: RainUploadProgress;

  /**  */
  @Input() jobs: any[];

  /** Dados das estações com nome e ID. */
  @Input() stations: any[] = [];

  /** Referência ao campo de upload de arquivos */
  @ViewChild('uploadField') uploadField: ElementRef;

  /**  */
  @Output() uploadStarted = new EventEmitter();

  /**
   * Indica se o upload está executando no servidor
   */
  get isUploadRunning() {
    // return this.currentFileUploadStatus == FileUploadStatus.SENDING || (
    //   this.uploadProgressDetails?.finished == false &&
    //   this.uploadProgressDetails?.startTime != null
    // );
    let activeStatus = ['COPIA', 'IMPORTACAO', 'CALCULO'];
    let isActive = (job: any) => activeStatus.includes(job.status);

    return this.jobs.find(isActive) != null;
  }

  /**
   * Indica se o upload terminou e se a mensagem já foi visualizada pelo usuário.
   */
  get isUploadFinishedAndNotSeen() {
    return (
      this.uploadProgressDetails?.finished == true &&
      this.uploadProgressDetails?.messageSeen == false
    );
  } 

  /**
   * Porcentagem do upload
   */
  get uploadPercent() {
    return this.uploadProgressDetails?.percent;
  }

  /**
   * Mensagem do status do upload
   */
  get uploadMessage() {

    let endTime = this.uploadProgressDetails?.endTime;
    endTime = endTime ? this.timespanService.formatDatetime(new Date(endTime)) : '';
    return `${this.uploadProgressDetails?.message}`;
  }

  constructor(private fileUploaderService: FileUploaderService, 
    private rainUploadQueryService: RainUploadQueryProgressService,
    private localStorageService: LocalStorageService,
    private service: ServiceService,
    private timespanService: TimespanService) { }

  /**
   * Ao iniciar o componente, busca os detalhes do upload mais recente que está em
   * andamento ou terminado.
   */
  ngOnInit(): void {
    // let userId = this.localStorageService.getUserId();
    // this.rainUploadQueryService.getUploadProgress(userId).subscribe(res => {
    //   this.uploadProgressDetails = res;
      
    //   if (res.finished) {
    //     this.currentFileUploadStatus = FileUploadStatus.FINISHED;
    //   } 
    // });
    this.service.getStationsData('PREFEITURA NITERÓI').subscribe((stations) => {
      this.stations = stations;
    });
  }

  /**
   * Dispara um click no botão de upload
   */
   triggerUploadField() {
    this.uploadField.nativeElement.click();
  }

  /**
   * Trata a seleção de arquivos para upload
   * @param event evento de mudança do campo, com o arquivo selecionado.
   */
  onFilesChanged(event: Event) {

    // this.selectedFile = Array.from((event.target as HTMLInputElement).files);
    this.selectedFile = (event.target as HTMLInputElement).files[0];
  }

  /**
   * Remove o arquivo previamente selecionado
   */
  removeFile() {
    console.log('limpou')
    this.selectedFile = null;
  }

  /**
   * Trata o envio do arquivo das chuvas ao servidor.
   */
  async sendFile() {

    this.currentFileUploadStatus = FileUploadStatus.SENDING;

    if (this.uploadProgressDetails) {
      this.uploadProgressDetails.percent = 0;
    }
    
    let file = this.selectedFile;
    let formData = new FormData();
    let { nome_estacao_original: stationName, id_estacao: stationId } = this.selectedStation;
    formData.append('rainFile', file, stationName);
    formData.append('userId', this.localStorageService.getUserId());
    formData.append('stationId', stationId);
    formData.append('stationName', stationName);

    // Inicia upload
    // await this.rainUploadQueryService.uploadFile(data);
    await this.fileUploaderService.upload(formData).toPromise();

    // Limpa o campo de upload
    this.removeFile();

    this.uploadStarted.emit();
  }

  /**
   * Marca a mensagem de resultado do upload como lida.
   */
  markUploadMessageAsSeen() {

    let userId = this.localStorageService.getUserId();
    this.rainUploadQueryService.markUploadMessageAsSeen(userId).subscribe(res => {
      this.uploadProgressDetails.messageSeen = true;
      this.uploadProgressDetails.percent = 0;
    });
  }

}
